import { cityStateMap } from '@csscompany/op-facility-finder';

type Facility = {
  id: string;
  slug: string;
  address: Array<{ text: string }>;
  latitude: Array<{ text: string }>;
  longitude: Array<{ text: string }>;
  renders: {
    data: {
      images: Array<{ image_url?: { url: string } }>;
    };
  };
  country: Array<{ text: string }>;
  brand_name: Array<{ text: string }>;
  facility_description: Array<{ text: string }>;
  city: Array<{ text: string }>;
  tags: Array<string>;
  facility_tags: Array<string>;
};

export const getFormattedFacilityData = (facility: Facility) => {
  const {
    id,
    slug,
    address,
    latitude,
    longitude,
    renders,
    country,
    brand_name,
    facility_description,
    city,
    tags,
    facility_tags,
  } = facility;
  const name =
    brand_name && brand_name.length > 0 ? brand_name[0].text.trim() : '';
  const images = renders?.data?.images;
  const cityName = city && city.length > 0 ? city[0].text.trim() : '';

  const tagNames = tags.filter((tag) => cityStateMap[tag]);

  return {
    id,
    city: cityStateMap[cityName]
      ? cityName
      : tagNames.length > 0
        ? tagNames[0]
        : '',
    slug,
    address: address && address.length > 0 ? address[0].text.trim() : '',
    latitude:
      latitude && latitude.length > 0 ? parseFloat(latitude[0].text) : 0,
    longitude:
      longitude && longitude.length > 0 ? parseFloat(longitude[0].text) : 0,
    logo: images && images.length > 0 ? images[0].image_url?.url : undefined,
    country: country && country.length > 0 ? country[0].text.trim() : '',
    renders: images,
    name,
    tags,
    facility_tags,
    description:
      facility_description && facility_description.length > 0
        ? facility_description[0].text
        : '',
  };
};
